var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-left":"","row":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","md8":"","lg6":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }